var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paid-membership-plan-note"},[_c('div',{staticClass:"description-wrapper"},[_c('img',{staticClass:"navigation-to-plan-selection",attrs:{"src":_vm.imageSrc}})])])}
var staticRenderFns = []

export { render, staticRenderFns }